import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../core/settings/settings.service';
import { ThemesService } from '../core/themes/themes.service';
import { Router } from '@angular/router';
import { FieldSectorService } from '../routes/agricola/fields/services/sectors.service';
import { Subscription } from 'rxjs';
import { GlobalFunction } from '../Services/public/globalFunction';
import { Report } from '../routes/agricola/fields/interfaces/reports.interface';
import { ReportsService } from '../routes/agricola/fields/services/reports.service';
import { Sector } from '../routes/agricola/incidences/Interface';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  currentTheme: any;
  toggle = false;
  margin = true;
  isOffsidebarOpen: boolean = false;
  report_selected: Report | null = null;
  create_report: Report | null = null;
  sector: Sector | null = null;

  reportSuscription: Subscription | undefined;
  createReportSuscription: Subscription | undefined;

  constructor(
    public themes: ThemesService,
    public settings: SettingsService,
    public route: Router,
    public reportService: ReportsService,
    public globalFunction: GlobalFunction,
    public fieldSerctorService: FieldSectorService
  ) {
    this.currentTheme = themes.getDefaultTheme();
  }
  ngOnDestroy() {
    if (this.reportSuscription) {
      this.reportSuscription.unsubscribe();
    }
    if (this.createReportSuscription) {
      this.createReportSuscription.unsubscribe();
    }
  }
  ngDoCheck(): void {
    this.margin = !this.route.url.includes('/agricola/lotes');
  }
  ngOnInit(): void {
    this.checkScreenWidth();

    this.reportSuscription = this.reportService.reportObservable$.subscribe(
      (report) => {
        this.isOffsidebarOpen = true;
        this.report_selected = report;
      }
    );

    this.createReportSuscription =
      this.reportService.createReportObservable$.subscribe((sector) => {
        console.log('se obtuvo el reporte', sector);
        this.isOffsidebarOpen = true;
        this.sector = sector;
      });
  }

  checkScreenWidth() {
    const isMobileOrTablet = window.innerWidth < 980;
    this.setCollapsedState(isMobileOrTablet);
  }

  setCollapsedState(isMobileOrTablet: boolean) {
    if (isMobileOrTablet) {
      this.settings.setLayoutSetting('isCollapsed', true);
    } else {
      let mode = Number(localStorage.getItem('menuMode'));
      if (mode == 1) {
        this.settings.setLayoutSetting('isCollapsed', false);
      } else {
        this.settings.setLayoutSetting('isCollapsed', true);
      }
    }
  }

  validateToggle() {
    let bool = this.settings.getLayoutSetting('isCollapsed');
    return bool ? 'aside-container-toggle' : 'aside-container';
  }

  validateToggleContent() {
    let bool = this.settings.getLayoutSetting('isCollapsed');
    return bool
      ? 'section-container section-container-toggle'
      : 'section-container';
  }
  toggleOffsidebar(reset: boolean) {
    this.isOffsidebarOpen = !this.isOffsidebarOpen;
    if (reset) {
      this.resetValues();
    }
  }
  goRequisitions() {
    if (this.report_selected) {
      this.globalFunction.goRequisitions('report', this.report_selected.id);
    }
  }
  resetValues() {
    this.reportService.setSectorCreateReport(null);
    this.reportService.setReportObservable(null);
    this.reportService.setViewPositionReport(null);
    this.reportService.setPositionReport(null);
  }
}
